import { useEffect, useMemo, useState } from 'react'
import { Search } from 'lucide-react'
import { getCollections } from '../api'
import type { Collection } from '../types'
import { CollectionCards } from '../components/CollectionCards'
import { CollectionTable } from '../components/CollectionTable'
import { CollectionViewToggle, type CollectionViewMode } from '../components/CollectionViewToggle'
import { ErrorState, Loading } from '../components/States'

export default function CollectionsPage() {
  const [rows,setRows]=useState<Collection[]>([])
  const [q,setQ]=useState('')
  const [loading,setLoading]=useState(true)
  const [error,setError]=useState('')
  const [view,setView]=useState<CollectionViewMode>('cards')

  async function load(){
    setLoading(true)
    setError('')
    try{
      setRows(await getCollections())
    }catch(e:any){
      setError(e.message)
    }finally{
      setLoading(false)
    }
  }

  useEffect(()=>{load()},[])

  const filtered=useMemo(
    ()=>rows.filter(
      r=>`${r.name||''} ${r.symbol||''} ${r.collection_address}`
        .toLowerCase()
        .includes(q.toLowerCase())
    ),
    [rows,q]
  )

  return <>
    <div className="page-title">
      <span className="eyebrow">Collections</span>
      <h1>Explore Solana collections.</h1>
      <p>
        Browse visually by default, switch to the detailed market table when needed,
        and open every collection through its permanent collection-address route.
      </p>
    </div>

    <div className="collection-tools">
      <label>
        <Search/>
        <input
          value={q}
          onChange={e=>setQ(e.target.value)}
          placeholder="Search collection name or address"
        />
      </label>

      <span className="collection-result-count">
        {filtered.length} collections
      </span>

      <CollectionViewToggle value={view} onChange={setView}/>
    </div>

    {loading
      ? <Loading/>
      : error
        ? <ErrorState error={error} retry={load}/>
        : view === 'cards'
          ? <CollectionCards rows={filtered}/>
          : <CollectionTable rows={filtered}/>}
  </>
}

